export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-header/index.ts